import { render, staticRenderFns } from "./StateModifiedAsterisk.vue?vue&type=template&id=daa076d8"
import script from "./StateModifiedAsterisk.vue?vue&type=script&lang=ts"
export * from "./StateModifiedAsterisk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports